import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IUserSubscriptionModel } from "../../models/UserSubscription";

interface IUserSubscriptionState {
  userSubscription: IUserSubscriptionModel | null;
}

const initialState: IUserSubscriptionState = {
  userSubscription: null,
};

const userSubscriptionSlice = createSlice({
  name: "userSubscription",
  initialState,
  reducers: {
    setUserSubscription: (state, action: PayloadAction<IUserSubscriptionModel | null>) => {
      state.userSubscription = action.payload;
    },
    setUserSubscriptionToInitial: (state) => {
      state.userSubscription = null;
    },
  },
});

export const { setUserSubscription, setUserSubscriptionToInitial } = userSubscriptionSlice.actions;

export default userSubscriptionSlice.reducer;
